import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../hooks/storeHooks";
import { selectEvidenceLoading } from "../../store/selectors/rectificationSelector";
import { selectIsTechManager } from "../../store/selectors/userSelectors";
import { DefectStatus } from "../../types/DefectStatus";
import { setRequestMoreInfo } from "../../store/slices/rectificationSlice";

export const EvidenceBodyTemplate = (rowData: any) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    
    const evidenceLoading = useAppSelector(selectEvidenceLoading);
    const isTechManager = useAppSelector(selectIsTechManager);

    if (rowData.status === DefectStatus.rectified) {
        if (evidenceLoading) {
            return <p>{t("defectsTable.loading")}</p>;
        }

        if (
            !isTechManager &&
            rowData.evidence === t("defectsTable.notProvided")
        ) {
            const onClick = () => {
                dispatch(
                    setRequestMoreInfo({
                        defectId: rowData.defectId,
                        inspectionId: rowData.inspectionId,
                        showDialog: true
                    })
                );
            };
            return (
                <p
                    className="font-semibold underline cursor-pointer read-more-btn"
                    onClick={onClick}
                >
                    {rowData.evidence}
                </p>
            );
        }

        return <p>{rowData.evidence}</p>;
    }
};